(() => {
  const selector = 'variant-selects[data-tt-hammock="true"]';

  const readVariants = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-tt-hammock-variants]')?.textContent || '[]');
    } catch (_error) {
      return [];
    }
  };

  const syncHiddenSize = (root, color) => {
    const variants = readVariants(root);
    const match = variants.find((variant) => variant.available && variant.options?.[0] === color)
      || variants.find((variant) => variant.options?.[0] === color);
    const size = match?.options?.[1];
    if (!size) return;

    const group = root.querySelector('[data-tt-option-position="2"]');
    if (!group) return;

    const radio = Array.from(group.querySelectorAll('input[type="radio"]')).find((input) => input.value === size);
    if (radio) {
      radio.checked = true;
      return;
    }

    const select = group.querySelector('select');
    if (!select) return;
    Array.from(select.options).forEach((option) => option.toggleAttribute('selected', option.value === size));
    select.value = size;
  };

  const initialize = (root) => {
    const selectedColor = root.querySelector('[data-tt-option-position="1"] input:checked')
      || root.querySelector('[data-tt-option-position="1"] select option[selected]');
    if (selectedColor) syncHiddenSize(root, selectedColor.value);
  };

  document.addEventListener('change', (event) => {
    const root = event.target.closest(selector);
    if (!root || !event.target.closest('[data-tt-option-position="1"]')) return;
    syncHiddenSize(root, event.target.value);
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(selector).forEach(initialize);
  });
})();
